export default __webpack_public_path__ + "static/media/Planograma.ff150b52.svg";